import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";

export default createQueryGroup(({ api }) => ({
  list: () => {
    return queryOptions({
      queryKey: ["bot_agents"],
      queryFn: () => api.get("./telephony/bot_agents", {}),
      placeholderData: keepPreviousData,
    });
  },
}));
